// libs
import React, { memo, useContext } from "react";
import styled from "@emotion/styled";

// defs
import { IMapOfString } from "global";

// context
import MenuContext from "shared/components/Header/DesktopHeader/components/Menu/MenuContext";

// helpers
import { generateTrackingUrlForMegaMenu } from "shared/components/Header/helpers";

const Container = styled.a`
    color: #666;
    text-transform: uppercase;
    cursor: pointer;
    text-decoration: none;

    &:hover {
        position: relative;
        color: #000;

        &:after {
            position: absolute;
            content: "";
            height: 2px;
            bottom: -2px;
            left: 0;
            right: 0;
            background: #000;
        }
    }
`;

interface ICategoryProps {
    data: IMapOfString;
}

function CategoryLink({ data }: ICategoryProps) {
    const { goToUrl } = useContext(MenuContext);

    const onClick: React.MouseEventHandler = e => {
        e.preventDefault();
        goToUrl(data);
    };

    return (
        <Container
            href={generateTrackingUrlForMegaMenu(data)}
            arial-label={data.title}
            onClick={onClick}
        >
            <div className="cl-title">{data.title}</div>
        </Container>
    );
}

export default memo(CategoryLink);
